import { makeSvgIcon } from '../makeSvgIcon'

export const circle = makeSvgIcon(<circle cx="12" cy="12" r="10" />)
